import React from 'react';
function Head() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "11",
    height: "11",
    fill: "none",
    viewBox: "0 0 11 11",
    className: "user-head"
  }, React.createElement("circle", {
    cx: "5.295",
    cy: "5.295",
    r: "4.47",
    stroke: "currentColor",
    strokeWidth: "1.65"
  }));
}
function Body() {
  return React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "9",
    fill: "none",
    viewBox: "0 0 20 9"
  }, React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.5 7.673a.831.831 0 01-.836.827.831.831 0 01-.835-.827V5.468c0-1.98-1.622-3.583-3.622-3.583H5.293c-2 0-3.622 1.604-3.622 3.583v2.205a.831.831 0 01-.835.827A.831.831 0 010 7.673V5.468C0 2.575 2.37.23 5.293.23h8.914C17.13.23 19.5 2.575 19.5 5.468v2.205z",
    clipRule: "evenodd"
  }));
}
export const User = _ref => {
  let {
    active
  } = _ref;
  return React.createElement("span", {
    "aria-hidden": "true",
    className: "navbar-user-wrapper ".concat(active ? 'active' : ''),
    "data-testid": "icon-user"
  }, React.createElement(Head, null), React.createElement(Body, null));
};